<template lang="pug">
div
    Header(:level="1", :text="titleText")
    TextBody(:text="line1", v-if="line1", customClass="mb-2")
    TextBody(:text="line2", v-if="line2", customClass="mb-8")
    Button(
        @click="clickHandler",
        :btnLabel="btnLabel",
        v-bind="$attrs",
        v-on="$listeners"
    )
</template>

<script lang="ts">
import Vue from "vue"
import TextBody from "./TextBody.vue"
import Header from "./Header.vue"
import Button from "./Button.vue"

export default Vue.extend({
  name: "ErrorHero",
  components: { Header, TextBody, Button },
  props: {
    clickHandler: Function,
    titleText: String,
    line1: String,
    line2: String,
    btnLabel: String,
  },
})
</script>
